// src/pages/Homepage.tsx
import { Grid } from '@mantine/core';
import { CourseSection } from '../components/dashboard/courses/CourseSection';
import { AppSection } from '../components/dashboard/apps/AppSection';
import { ProfileSection } from '../components/dashboard/profile/ProfileSection';

export function Homepage() {
  return (
    <Grid gutter={'xs'}>
      <Grid.Col span={{ base: 12, xl: 3 }} order={{ base: 1, xl: 3 }}>
        <ProfileSection />
      </Grid.Col>

      <Grid.Col span={{ base: 12, xl: 5 }} order={{ base: 2, xl: 1 }}>
        <CourseSection />
      </Grid.Col>

      <Grid.Col span={{ base: 12, xl: 4 }} order={{ base: 3, xl: 2 }}>
        <AppSection />
      </Grid.Col>
    </Grid>
  );
}
